import styled from "styled-components";

const StyledHeading = styled.h3`
  font-size: 1.4em;
  text-transform: uppercase;
  margin-bottom: -0.8rem;

  color: var(--color-grey-400);
`;

const HeadingSection = ({ text }) => {
  return <StyledHeading>{text}</StyledHeading>;
};

export default HeadingSection;
